import(/* webpackMode: "eager" */ "/codebuild/output/src4165703322/src/app/login/page.tsx");
